export enum DecimationType {
    None = 0,
    OnlyInlines = 1,
    OnlyXlines = 2,
}